// RFC 3339 format
export const formatDate = (d: string | number) => {
  const date = new Date(d);
  if (typeof date === 'undefined' || String(date) === 'Invalid Date') {
    return '';
  }
  return date.toISOString();
};
